export default "__VITE_ASSET__zc7MWmKt__"